import { Controller } from "@hotwired/stimulus"
import { notifyParentOfUrlChange } from "../utils/iframe_messaging"

// Connects to data-controller="surah-selector"
export default class extends Controller {
  static targets = ["surahSelect", "ayahSelect", "goButton"]

  connect() {
    this.initializeAyahOptions()
    this.updateGoButtonState()
  }

  initializeAyahOptions() {
    const surahSelect = this.surahSelectTarget
    if (surahSelect.value !== "") {
      // If a surah is already selected (e.g., from URL), populate ayah options
      this.updateAyahOptions()
      
      // If there's an ayah parameter in the URL, select it
      const urlParams = new URLSearchParams(window.location.search)
      const ayahParam = urlParams.get('ayah')
      if (ayahParam) {
        const ayahSelect = this.ayahSelectTarget
        ayahSelect.value = ayahParam
      }
    }
  }

  updateAyahOptions() {
    const surahSelect = this.surahSelectTarget
    const ayahSelect = this.ayahSelectTarget
    const selectedOption = surahSelect.options[surahSelect.selectedIndex]
    
    // Clear existing options
    ayahSelect.innerHTML = ""
    
    if (surahSelect.value === "") {
      // No surah selected
      ayahSelect.disabled = true
      ayahSelect.innerHTML = '<option value="">First select a Surah...</option>'
      this.updateGoButtonState()
      return
    }
    
    // Get verse count from data attribute
    const versesCount = parseInt(selectedOption.dataset.versesCount)
    
    // Enable ayah select and populate options
    ayahSelect.disabled = false
    ayahSelect.innerHTML = '<option value="">Select Ayah (optional)</option>'
    
    for (let i = 1; i <= versesCount; i++) {
      const option = document.createElement('option')
      option.value = i
      option.textContent = `Ayah ${i}`
      ayahSelect.appendChild(option)
    }
    
    this.updateGoButtonState()
  }

  updateGoButtonState() {
    const surahSelect = this.surahSelectTarget
    const goButton = this.goButtonTarget
    
    if (surahSelect.value === "") {
      goButton.disabled = true
    } else {
      goButton.disabled = false
    }
  }

  navigate() {
    const surahSelect = this.surahSelectTarget
    const ayahSelect = this.ayahSelectTarget
    
    if (surahSelect.value === "") {
      return
    }
    
    const surahId = surahSelect.value
    let url = `/${surahId}`
    
    // Add ayah parameter if selected
    if (ayahSelect.value !== "") {
      url += `?ayah=${ayahSelect.value}`
    }
    
    // Preserve current query parameters
    const currentUrl = new URL(window.location)
    const params = new URLSearchParams(currentUrl.search)
    
    // Add ayah if selected, otherwise remove it
    if (ayahSelect.value !== "") {
      params.set('ayah', ayahSelect.value)
    } else {
      params.delete('ayah')
    }
    
    // Build final URL
    if (params.toString()) {
      url += (url.includes('?') ? '&' : '?') + params.toString()
    }
    
    // Navigate to the chapter/ayah
    notifyParentOfUrlChange(url);
    window.location.href = url
  }
}